import React from 'react'

const Eth = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="22"
            fill="none"
            viewBox="0 0 23 22"
        >
            <circle cx="11.877" cy="11" r="11" fill="#EDF0F4"></circle>
            <path
                fill="#343434"
                d="M11.847 4.4l-.087.297v8.625l.087.087 4.004-2.367L11.847 4.4z"
            ></path>
            <path fill="#8C8C8C" d="M11.847 4.4l-4.003 6.643 4.003 2.366V4.4z"></path>
            <path
                fill="#3C3C3B"
                d="M11.847 14.167l-.049.06v3.072l.05.144 4.005-5.641-4.006 2.365z"
            ></path>
            <path
                fill="#8C8C8C"
                d="M11.847 17.443v-3.276l-4.003-2.365 4.003 5.641z"
            ></path>
            <path
                fill="#141414"
                d="M11.847 13.409l4.004-2.366-4.004-1.82v4.186z"
            ></path>
            <path
                fill="#393939"
                d="M7.844 11.043l4.003 2.366V9.223l-4.003 1.82z"
            ></path>
        </svg>
    )
}

export default Eth